module.exports = __webpack_public_path__ + "/images/price-tend-down.10a62d2.svg";